import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  CircularProgress,
  Tooltip,
  useTheme
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined'
import CodeIcon from '@mui/icons-material/Code'
import DeleteIcon from '@mui/icons-material/Delete'
import SetupDialog from './SetupDialog'
import Pagination from '../Pagination'
import noDataImg from '../../assets/websiteVisitor.png'
import DeleteConfirmDialog from './DeleteConfirmDialog'

const fetchDomainData = (page, limit) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const total = 12
      const all = Array.from({ length: total }, (_, i) => ({
        domain: `domain${i + 1}.com`,
        createdAt: `Wed Apr ${23 + (i % 7)} 2025`,
        testStatus: i % 2 === 0 ? 'Not tested' : 'Tested'
      }))
      const start = (page - 1) * limit
      resolve({
        data: all.slice(start, start + limit),
        total
      })
    }, 1000)
  })

const SetupPage = () => {
  const theme = useTheme()

  const [openDialog, setOpenDialog] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [domainData, setDomainData] = useState([])
  const [domain, setDomain] = useState('')
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [total, setTotal] = useState(0)

  const handleOpen = () => setOpenDialog(true)
  const handleClose = () => setOpenDialog(false)

  const loadDomains = async (pageNum = 1, pageSize = 5) => {
    setLoading(true)
    const { data, total } = await fetchDomainData(pageNum, pageSize)
    setDomainData(data)
    setTotal(total)
    setLoading(false)
  }

  useEffect(() => {
    loadDomains(page, limit)
  }, [page, limit])

  return (
    <>
      <Box
        sx={{
          display: !domainData.length ? 'none' : 'flex',
          justifyContent: 'flex-end',
          mb: 2
        }}
      >
        <Button variant='contained' startIcon={<AddIcon />} onClick={handleOpen}>
          Add New
        </Button>
      </Box>

      <Paper elevation={2} sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
        {loading
          ? (
            <Box sx={{ textAlign: 'center', py: 6 }}>
              <CircularProgress />
            </Box>
            )
          : domainData.length === 0
            ? (
              <Box sx={{ textAlign: 'center', py: 8 }}>
                <img src={noDataImg} alt='No Data' style={{ width: '200px', marginBottom: 16 }} />
                <Typography variant='h6' sx={{ mb: 1 }}>
                  No domains configured
                </Typography>
                <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
                  Start by adding your website domain to generate tracking code.
                </Typography>
                <Button variant='contained' onClick={handleOpen}>
                  Add Your First Domain
                </Button>
              </Box>
              )
            : (
              <>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell><strong>DOMAIN</strong></TableCell>
                        <TableCell><strong>CREATED</strong></TableCell>
                        <TableCell><strong>TEST STATUS</strong></TableCell>
                        <TableCell align='center'><strong>ACTIONS</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {domainData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}>
                            {row?.domain}
                          </TableCell>
                          <TableCell>{row?.createdAt}</TableCell>
                          <TableCell>
                            <Chip
                              label={row?.testStatus}
                              size='small'
                              sx={{
                                bgcolor:
                                  row?.testStatus === 'Tested'
                                    ? theme.palette.primary.main
                                    : theme.palette.grey[700],
                                color: 'white'
                              }}
                            />
                          </TableCell>
                          <TableCell align='center'>
                            <Tooltip title='Test code installation' placement='top' arrow>
                              <IconButton>
                                <SpeedOutlinedIcon fontSize='small' sx={{ color: theme.palette.text.secondary }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title='See Code' placement='top' arrow>
                              <IconButton>
                                <CodeIcon fontSize='small' sx={{ color: theme.palette.text.secondary }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title='Delete' placement='top' arrow>
                              <IconButton
                                onClick={() => {
                                  setDomain(row?.domain)
                                  setOpenDelete(true)
                                }}
                              >
                                <DeleteIcon fontSize='small' sx={{ color: theme.palette.text.secondary }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ m: 1 }}>
                  <Pagination
                    limit={limit}
                    handleLimitChange={(e) => {
                      setLimit(e.target.value)
                      setPage(1)
                    }}
                    page={page}
                    length={domainData.length}
                    total={total}
                    setPage={setPage}
                  />
                </Box>
              </>
              )}
      </Paper>

      <SetupDialog open={openDialog} onClose={handleClose} />

      <DeleteConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={() => {
          // delete logic here
          setOpenDelete(false)
        }}
        domain={domain}
      />
    </>
  )
}

export default SetupPage
